import { NavigateFunction } from "react-router-dom";
import { DefectDataItem } from "../types/DefectsDataItem";
import { SharedDefectItem } from "../types/SharedDefectItem";
import { DefectStatus } from "../types/DefectStatus";
import { searchAssets } from "../services/AssetsService";
import { getTranslationObject } from "../services/Translation";

const t = getTranslationObject();

export const navigateToRectificationView = <T extends { defectId: number }>(defects: T[] | undefined, defectId: number, navigate: NavigateFunction, prefix: string) => {
    let defectToNavigate;

    if (defects?.length) {
        defectToNavigate = defects.find((defect: T) => defect.defectId?.toString() === defectId.toString());
    }

    if (defectToNavigate) {
        navigate(`/${prefix}/${defectId}/rectification`);
    }
}

export const getRectificationUrl = <T extends { defectId: number }>(defects: T[] | undefined, defectId: number, navigate: NavigateFunction, prefix: string) => {
    let defectToNavigate;

    if (defects?.length) {
        defectToNavigate = defects.find((defect: T) => defect.defectId?.toString() === defectId.toString());
    }

    if (defectToNavigate) {
        return `/${prefix}/${defectId}/rectification`;
    }

    return "";
}

export const navigateSharedDefectRectificationView = <T extends { defectId: number }>(sharedDefects: T[] | undefined, defectId: number, navigate: NavigateFunction, prefix: string) => {
    let defectToNavigate;

    if (sharedDefects?.length) {
        defectToNavigate = sharedDefects.find((defect: T) => defect.defectId?.toString() === defectId.toString());
    }

    if (defectToNavigate) {
        navigate(`/${prefix}/${defectId}/rectification`);
    }
}

export const getDefectEvidenceValue = (hasEvidence: boolean) =>
    t(hasEvidence ? "defectsTable.provided" : "defectsTable.notProvided");

export const mapRectifiedEvidence = async (
    items: (DefectDataItem | SharedDefectItem)[]
) => {
    const rectifiedDefects = items.filter(
        (item) => item.status === DefectStatus.rectified
    );

    if (!rectifiedDefects.length) {
        return items;
    }

    const results = await Promise.all(
        rectifiedDefects.map((item) => {
            const imo = item.imo ?? (item as DefectDataItem).vessel.imo;
            return searchAssets(`imo=${imo}&defect-id=${item.defectId}`);
        })
    );

    const evidenceByDefectId = new Map(
        rectifiedDefects.map((defect, index) => [
            defect.defectId,
            getDefectEvidenceValue(!!results[index]?.length),
        ])
    );

    return items.map((item) => {
        if (evidenceByDefectId.has(item.defectId)) {
            return { ...item, evidence: evidenceByDefectId.get(item.defectId) };
        }
        return item;
    });
};
